/**
 *  @class
 *  @function LoopToggleBoxes
 */
if (!customElements.get('toggle-box')) {
  class LoopToggleBoxes extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('.toggle-box--button');

      this.button.addEventListener('click', () => {
        this.toggleAttribute('open');
      });
    }
  }
  customElements.define('toggle-box', LoopToggleBoxes);
}